import React, { useEffect } from 'react'

import { observer } from 'mobx-react-lite'

import { $auth } from 'ziphy-web-shared/basic/entities/auth'
import { useIntervalTimer } from 'ziphy-web-shared/basic/hooks'
import { globalLoaderHandlers, useLoaderSubscribe } from 'ziphy-web-shared/basic/utils'

import Notice from '@library/notifications/Notice'

import { $notices } from '@store'

import mainConfig from '@config/main'

import styles from './Notifications.module.scss'

const NotificationsViewer = () => {
  // todo: remove useIntervalTimer and use only eventsListener
  const { start, stop } = useIntervalTimer({
    duration: mainConfig.notifications.updateInterval,
    callback: async () => {
      await $notices.getNew()
    },
    autoStart: false,
  })

  useLoaderSubscribe(globalLoaderHandlers.EVENT, async () => {
    await $notices.getNew()
  })

  useEffect(() => {
    if ($auth.isLogged) {
      $notices.clear()
      $notices.getHistory()
      start()
    } else {
      stop()
      $notices.clear()
    }

    return () => {
      stop()
      $notices.clear()
    }
  }, [$auth.isLogged]) //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {$notices.popups.length > 0 && (
        <div className={styles.popupNotices}>
          {$notices.popups.map((item) => (
            <Notice options={item} key={item.id} />
          ))}
        </div>
      )}
    </>
  )
}

export default observer(NotificationsViewer)
